import { Injectable } from '@angular/core';
import { ViewProvider } from '../view/view';

@Injectable()
export class AcessoexternoProvider {

  constructor(public view:ViewProvider) {
  }

  openInstagram(){
    this.view.abrirLink('https://www.instagram.com/oficialnutrimar/');
  }

  entrarEmContato(){
    this.view.showMessage("Falta o numero do whatts, ou outro link de cominicação")
    // this.view.abrirLink('https://api.whatsapp.com/send?phone=557536226454');
  }
}



// WEBPACK FOOTER //
// ./src/providers/acessoexterno/acessoexterno.ts